var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkybetinline = function SvgSkybetinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 40,
    fill: "none",
    viewBox: "0 0 140 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#skybet_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23336A",
    d: "M63.286 3H3.132C1.416 3 0 4.404 0 6.106v27.788C0 35.596 1.416 37 3.132 37h60.11V3h.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#skybet_inline_svg__b)",
    d: "M63.285 3h73.583C138.584 3 140 4.404 140 6.106v27.788c0 1.702-1.416 3.106-3.132 3.106H63.285V3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#skybet_inline_svg__c)",
    d: "M63.285 3.68h73.369c-2.36 10.213-11.285 16.81-14.674 16.81H63.285V3.68Z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#skybet_inline_svg__d)",
    d: "M63.286 3.68H4.033c2.36 10.213 11.284 16.81 14.674 16.81h44.579V3.68Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.789 34.957c.429.213 1.244.468 2.317.468 1.802.043 2.789-.638 3.518-2.255l9.697-21.447c-.386-.212-1.287-.468-2.017-.468-1.244-.042-2.917.213-3.99 2.766l-3.132 7.362-6.178-9.915c-.387-.128-1.373-.298-2.06-.298-2.188 0-3.39.809-4.634 2.17l-6.007 6.468 4.806 7.532c.9 1.362 2.06 2.085 3.947 2.085 1.244 0 2.274-.297 2.746-.51l-5.75-8.723 4.12-4.34 6.736 10.51-4.12 8.595m-12.743-8.085c0 1.575-.644 2.511-3.733 2.511-.429 0-.772-.043-1.115-.085V8.277c0-1.575.557-3.277 3.69-3.277.386 0 .815.043 1.158.128v21.744m-6.393-3.191c0 2.936-1.93 5.106-5.878 5.532-2.875.298-6.994-.043-8.967-.256a4.164 4.164 0 0 1-.129-1.02c0-2.554 1.416-3.15 2.703-3.15 1.373 0 3.518.256 5.106.256 1.759 0 2.317-.596 2.317-1.15 0-.723-.687-1.02-2.06-1.319l-3.732-.723c-3.133-.596-4.763-2.723-4.763-4.979 0-2.766 1.974-5.063 5.835-5.489 2.918-.298 6.479.043 8.453.255.085.34.085.639.085.979 0 2.553-1.373 3.106-2.703 3.106-1.03 0-2.574-.17-4.376-.17-1.802 0-2.574.51-2.574 1.107 0 .638.729.893 1.845 1.106l3.56.638c3.69.681 5.278 2.724 5.278 5.277m57.965 7.234h-6.006c-.687 0-1.287-.085-1.717-.213-.429-.128-.729-.298-.944-.51a1.696 1.696 0 0 1-.471-.809 4.25 4.25 0 0 1-.13-1.064V11.553c0-.383.044-.723.13-1.064.085-.298.214-.553.471-.808.215-.213.558-.383.944-.51.43-.128.987-.171 1.674-.171h5.792c1.76 0 3.218.128 4.376.426 1.159.297 2.146.68 2.875 1.191.73.51 1.244 1.106 1.545 1.787.3.681.472 1.405.472 2.213 0 1.106-.344 2-.987 2.808-.687.809-1.63 1.405-2.832 1.83l-.6.213.6.17c1.716.468 2.918 1.15 3.647 2 .73.851 1.073 1.83 1.073 2.936 0 2.043-.816 3.575-2.446 4.681-1.588 1.107-4.119 1.66-7.466 1.66M76.8 27h3.26c1.588 0 2.704-.213 3.39-.596.73-.425 1.116-1.149 1.116-2.17 0-.298-.043-.596-.172-.894a1.945 1.945 0 0 0-.686-.893c-.3-.255-.773-.426-1.33-.596-.558-.17-1.288-.213-2.189-.213H76.8V27m0-8.851h3.26c.773 0 1.416-.085 1.888-.213a3.38 3.38 0 0 0 1.245-.596c.3-.255.515-.51.643-.85.13-.298.172-.596.172-.937 0-.85-.343-1.49-.987-1.915-.643-.383-1.63-.595-3.09-.595H76.8v5.106m22.096 8.213v-4.128h7.809c1.845 0 2.875-.638 2.875-3.021 0-.553-.043-1.107-.172-1.447H98.896v-4.298h8.024c1.844 0 2.874-.638 2.874-2.979a6.42 6.42 0 0 0-.171-1.446H97.609c-3.432 0-4.076 1.787-4.076 3.574v18.255h13.858c1.845 0 2.875-.638 2.875-2.978 0-.554-.043-1.107-.171-1.49l-11.199-.042m25.872-12.851h4.334c1.416 0 2.874-.639 2.874-3.447 0-.34-.043-.724-.085-1.021h-16.819c-1.416 0-2.875.638-2.875 3.446 0 .34.043.724.086 1.064h7.122v17.362c.386.085.858.085 1.33.085 3.304 0 4.076-.936 4.076-2.638l-.043-14.851"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skybet_inline_svg__b",
    x1: 101.627,
    x2: 101.627,
    y1: 36.979,
    y2: 3.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#C51F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#941724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C131F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skybet_inline_svg__c",
    x1: 99.948,
    x2: 99.948,
    y1: 3.807,
    y2: 16.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D36B75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#D5515D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#D63C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#D72D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#D82535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D82233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skybet_inline_svg__d",
    x1: 33.66,
    x2: 33.66,
    y1: 2.531,
    y2: 36.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#EBEFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#BECDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#97AED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#7694C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#5B7FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#466FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#3764AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#2F5DA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C5BA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "skybet_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v40H0z"
  })))));
};
export default SvgSkybetinline;